var _effectorFileName = "/builds/gmini/front-common/src/components/ErrorTooltip/ErrorTooltip.tsx";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { Tooltip } from '@gmini/ui-kit';
import { Wrapper, Description, Body } from "./ErrorTooltip.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorTooltip = function ErrorTooltip(_ref) {
  var errorText = _ref.errorText,
      description = _ref.description,
      children = _ref.children;
  return /*#__PURE__*/_jsx(Tooltip, {
    noMaxWidth: true,
    placement: "bottom",
    title: /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsx(Body, {
        children: errorText
      }), description && /*#__PURE__*/_jsx(Description, {
        children: description
      })]
    }),
    children: children
  });
};